// @ts-nocheck
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  setUnsavedChanges,
  showUnsavedModal,
  hideUnsavedModal,
  saveModuleData,
  discardModuleChanges,
  clearModuleUnsavedState,
  updateModuleCurrentData,
  setPendingAction
} from '../redux/slices/unsaved/unsaved';

export const useUnsavedChanges = (moduleName) => {
  const dispatch = useDispatch();

  const moduleState = useSelector((state) => state.unsaved.modules[moduleName]);

  const hasUnsavedChanges = moduleState?.hasUnsavedChanges || false;
  const shouldShowUnsavedModal = moduleState?.shouldShowUnsavedModal || false;
  const pendingAction = moduleState?.pendingAction;
  const currentData = moduleState?.currentData;
  const lastSavedData = moduleState?.lastSavedData;

  const setUnsaved = useCallback(
    (hasChanges, data = null) => {
      dispatch(
        setUnsavedChanges({
          moduleName,
          hasUnsavedChanges: hasChanges,
          currentData: data
        })
      );
    },
    [dispatch, moduleName]
  );

  const showModal = useCallback(
    (pendingAction = null) => {
      dispatch(showUnsavedModal({ moduleName, pendingAction }));
    },
    [dispatch, moduleName]
  );

  const hideModal = useCallback(() => {
    dispatch(hideUnsavedModal({ moduleName }));
  }, [dispatch, moduleName]);

  const markAsSaved = useCallback(
    (savedData) => {
      dispatch(saveModuleData({ moduleName, savedData }));
    },
    [dispatch, moduleName]
  );

  const discardChanges = useCallback(() => {
    dispatch(discardModuleChanges({ moduleName }));
  }, [dispatch, moduleName]);

  const clearModule = useCallback(() => {
    dispatch(clearModuleUnsavedState({ moduleName }));
  }, [dispatch, moduleName]);

  const updateCurrentData = useCallback(
    (data) => {
      dispatch(updateModuleCurrentData({ moduleName, currentData: data }));
    },
    [dispatch, moduleName]
  );

  const setPending = useCallback(
    (action) => {
      dispatch(setPendingAction({ moduleName, pendingAction: action }));
    },
    [dispatch, moduleName]
  );

  return {
    hasUnsavedChanges,
    shouldShowUnsavedModal,
    pendingAction,
    currentData,
    lastSavedData,
    setUnsaved,
    showModal,
    hideModal,
    markAsSaved,
    discardChanges,
    clearModule,
    updateCurrentData,
    setPending
  };
};
